import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import QuoteData from '../../Models/QuoteData';
import ListTileSwitch from '../../components/Overview/ListTileSwitch';
import { useRecentQuotes } from '../../features/quote/application/quoteQueries';
import { useQuoteSelectionStore } from '../../features/quote/application/quoteSelectionStore';

export default function QuoteOverview(): JSX.Element {
  const [listFormat, setListFormat] = useState(true);
  const { data: quotes } = useRecentQuotes();
  const selectQuote = useQuoteSelectionStore((state) => state.selectQuote);

  const renderList = (): JSX.Element => (
    <div className="body table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>DATE</th>
            <th>DISCOUNT</th>
            <th>QUOTATION PERIOD</th>
            <th>TOTAL</th>
            <th>CURRENCY</th>
            <th>SAVE NAME</th>
            <th>OVERWRITE IF EXISTS</th>
            <th>...</th>
          </tr>
        </thead>
        <tbody>
          {quotes?.map((quote: QuoteData, i) => {
            return (
              <tr key={i}>
                <td>{new Date(quote.createdOn).toISOString()}</td>
                <td>
                  {quote.discount} - {quote.discountType}
                </td>
                <td>{quote.quotationPeriod}</td>
                <td>{quote.totalAmount}</td>
                <td>{quote.currency}</td>
                <td>{quote.saveName}</td>
                <td>{quote.overwriteIfExist ? 'Yes' : 'No'}</td>
                <td>
                  <Link to="/finance/quotes/details">
                    <button
                      onClick={() => {
                        selectQuote(quote);
                      }}
                      className="btn btn-primary"
                    >
                      More details
                    </button>
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

  const renderTiles = (): JSX.Element => (
    <div className="row">
      {quotes?.map((quote: QuoteData, index) => {
        return (
          <div className="col-xl-4 col-lg-6 col-md-12" key={index}>
            <Card>
              <Card.Body>
                <Card.Title>{index + 1}</Card.Title>
                <Card.Text>
                  <strong>Date:</strong>{' '}
                  {new Date(quote.createdOn).toISOString()}
                  <br />
                  <strong>Discount: </strong>
                  <span>{quote.discount ?? 'not available'}</span>
                  <br />
                  <strong>Quotation Period: </strong>
                  <span>{quote.quotationPeriod ?? 'not available'}</span>
                  <br />
                  <strong>Total: </strong>
                  <span>{quote.totalAmount ?? 'not available'}</span>
                  <br />
                  <strong>Currency: </strong>
                  <span>{quote.currency ?? 'not available'}</span>
                  <br />
                  <strong>Save Name: </strong>
                  <span>{quote.saveName ?? 'not available'}</span>
                  <br />
                  <strong>Overwrite If Exist: </strong>
                  <span>{quote.overwriteIfExist ? 'Yes' : 'No'}</span>
                  <br />
                </Card.Text>
                <Link to="/finance/quotes/details">
                  <button
                    onClick={() => {
                      selectQuote(quote);
                    }}
                    className="btn btn-primary"
                  >
                    More details
                  </button>
                </Link>
              </Card.Body>
            </Card>
          </div>
        );
      })}
    </div>
  );

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header d-flex justify-content-between">
          <h2>
            My Last Quotes
            <small>My quotes of the last 3 months</small>
          </h2>
          <ListTileSwitch
            setList={() => {
              setListFormat(true);
            }}
            setTile={() => {
              setListFormat(false);
            }}
          />
        </div>
        {listFormat ? renderList() : null}
      </div>
      {!listFormat ? renderTiles() : null}
    </div>
  );
}
